import {PageProps} from '@/types';
import {useState} from "react";
import {InteractionStats} from "@/types/interactionStats";
import {Person} from "@/types/person";
import {Interaction} from "@/types/interaction";
import ObituaryComponent from "@/Organisms/Page/Page";
import Page from "@/Pages/Page";
import InteractionModal, {ActionType} from "@/Organisms/Modals/InteractionModal";
import {CommercialPageType} from "@/Atoms/Commercial";
import AdvertisementSection from "@/Organisms/Advertisements/AdvertisementSection";
import {relativeRoute} from "@/helpers/relativeRoute";
import {router} from "@inertiajs/react";
import {MetaTag} from "@/types/MetaTab";
import moment from "moment";
import ObituaryType from "@/types/ObituaryType";

export default ({person, options, showInteractions, stats, interactions, claimed, background, ziggy, flash}: PageProps<{
  person: Person,
  options: {
    floristUrl: string
    postcardUrl: string
  }
  showInteractions: boolean
  stats: InteractionStats,
  interactions: {
    data: Interaction[],
    pages: number,
    page: number,
  },
  // onPostInteraction: (input: any) => Promise<any>,
  claimed: boolean,
  background: string
  ziggy: {
    location: string
  },
  flash: {
    message: string
  }
}>) => {


  const [actionType, setActionType] = useState<ActionType>(ActionType.None)
  const [isSavingCondolence, setIsSavingCondolence] = useState(false)
  const [errors, setErrors] = useState()
  const [closeModalHandler, setCloseModalHandler] = useState<(promise:any) => void>()
  const [mobileState, setMobileState] = useState(false)
  const [showReviewMessage, setShowReviewMessage] = useState<boolean>(false)

  const [modalPayload, setModalPayload] = useState<{
    text?: string,
    name?: string,
    email?: string,
    parent_interaction_id?: number,
    youtube_url?: '',
    files?: [],
  }>()
  const handleAddReply = (interactionId: number, message: string): Promise<any> => new Promise((resolve) => {
    setModalPayload({
      text: message,
      parent_interaction_id: interactionId,

      // if user is logged in, add the data in here
    })
    setActionType(ActionType.CondolenceReply)
    setCloseModalHandler(() => resolve);
  });


  const handleSubmitCondolence = (payload: any) => {

    // convert payload so file upload and default image array are understood by http form data
    const meta: any[] = [];
    const files: any[] = [];
    payload.files?.forEach((file: any, index: number) =>
    {
      if (file.url instanceof File){
        const fileIndex = files.push(file.url) -1
        meta.push({index, fileIndex, type: 'file'})
      } else {
        meta.push({index, ...file})
      }
    })

    const formattedPayload = {...payload, files, meta}
    setIsSavingCondolence(true)
    router.post(
      relativeRoute('obituary.add-interaction', {person: person.slug}),
      formattedPayload,
      {
        preserveScroll: true,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
        onSuccess: () => {
          setIsSavingCondolence(false)

          closeModalHandler && closeModalHandler(true)
          setActionType(ActionType.None)

        },
        onError: (errors) => {
          setIsSavingCondolence(false)
          // @ts-ignore
          setErrors(errors)
        },
      }
    )
  }

  const handleAddHeart = (interactionId: number): Promise<boolean> => new Promise((resolve, reject) => {
    router.post(
      relativeRoute('obituary.heart', {person: person.slug, interaction: interactionId}),
      {},
      {
        preserveScroll: true,
        onSuccess: () => {
          resolve(true);
        },
        onError: (errors) => {
          reject(errors)
        },
      }
    )
  })

  const handleCancelCondolence = () => {
    closeModalHandler && closeModalHandler(true)
    setActionType(ActionType.None)
  }

  const functions = {
    OnAddCondolence: () => {
      setModalPayload({
        text: '',
        // if user is logged in, add the data in here
      })
      setActionType(ActionType.Condolence)
    },
    OnAddFlower: () => {
      setModalPayload({
        text: '',
        // if user is logged in, add the data in here
      })
      setActionType(ActionType.Flower)
    },
    OnAddCandle: () => {
      setModalPayload({
        text: '',
        // if user is logged in, add the data in here
      })
      setActionType(ActionType.Candle)
    },
    OnSendCard: () => {
      window.open(options.postcardUrl);
    },
    OnSendBouquet: () => {
      window.open(options.floristUrl);
    },
    OnSetMobileState: (state: boolean) => {
      setMobileState(state)
    }
  }

  const metaTags: MetaTag[] = [
    // OpenGraph
  {
    property: 'og:title',
    content: person.name + ' - Mensenlinq',
  },{
    property: 'og:type',
    content: 'website',
  },{
    property: 'og:description',
      content: person.name + ' - Mensenlinq',
  },{
    property: 'og:image',
    content: ziggy.location + '/card.jpg',
  },{
      property: 'og:url',
      content: ziggy.location,
  },

  // Twitter
  {
    property: 'twitter:card',
    content: 'summary_large_image',
  },{
    property: 'twitter:title',
      content: person.name + ' - Mensenlinq',
  },{
    property: 'twitter:description',
      content: person.name + ' - Mensenlinq',
  },{
    property: 'twitter:url',
    content: ziggy.location,
  },{
    property: 'twitter:image',
    content: ziggy.location + '/card.jpg',
  }]

  // console.log(person)
  const deceasedDateString = person.deceased_date ? '&#10013; ' + moment(person.deceased_date).format('LL') : ''
  const title = `${person.name} ${deceasedDateString} \u2022 overlijdensbericht en condoleances`;
  const isStandardObituary = person.obituary_type !== ObituaryType.Extended;
  const isPlatformHack = person.options?.platform_hack === true
  return (
    <Page
      title={title}
      pageType={CommercialPageType.ObituaryDetail}
      adUnit={'obituary'}
      metaTags={metaTags}
      mobileScaling={1.0}
    >

      <ObituaryComponent
        showInteractions={showInteractions}
        options={options}
        person={person}
        stats={stats}
        interactions={interactions}
        onAddReply={handleAddReply}
        onAddHeart={handleAddHeart}
        claimed={claimed}
        background={background}
        mobileMenuIsOpen={mobileState}
        functions={functions}
        flash={flash}
      />

      {isStandardObituary && <AdvertisementSection className={'bg-beige'} />}

      <InteractionModal
        isPlatformHack={isPlatformHack}
        action={actionType}
        privateOnly={person.options?.private_message_only}
        publicOnly={isStandardObituary}
        isLoading={isSavingCondolence}
        isObituary={claimed}
        onSubmit={handleSubmitCondolence}
        onCancel={handleCancelCondolence}
        defaultValues={modalPayload}
        inputErrors={errors}
      />

    </Page>
  );
}
